import React from "react";
import { TeachingAidOption } from "../../../models/financing-request/teaching-aid-option/TeachingAidOption";
import HighSchoolTeachingAidOption from "../../../models/financing-request/teaching-aid-option/HighSchoolTeachingAidOption";
import { Grid, FormControlLabel, Switch } from "@material-ui/core";
import { nameof } from "../../../utilities/utilities";

interface Props {
  teachingAidOption: TeachingAidOption;
  onChange: (e: any) => void;
}

export default function HighTeachingAidItem({
  teachingAidOption,
  onChange
}: Props) {
  let highSchoolTeachingAidOption = teachingAidOption as HighSchoolTeachingAidOption;

  return (
    <>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <FormControlLabel
          value={highSchoolTeachingAidOption.regular || false}
          checked={highSchoolTeachingAidOption.regular || false}
          name={nameof<typeof highSchoolTeachingAidOption>("regular")}
          control={<Switch color="secondary" />}
          label="Posebna nastavna sredstva i pomagala - izvođenje nastave"
          labelPlacement="end"
          onChange={onChange}
        />
      </Grid>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <FormControlLabel
          value={highSchoolTeachingAidOption.practical || false}
          checked={highSchoolTeachingAidOption.practical || false}
          name={nameof<typeof highSchoolTeachingAidOption>("practical")}
          control={<Switch color="secondary" />}
          label="Posebna nastavna sredstva i pomagala - izvođenje praktične nastave"
          labelPlacement="end"
          onChange={onChange}
        />
      </Grid>
    </>
  );
}
